{
  "version": 1,
  "asset_id": "13a18b1e-d6b4-4083-9318-dbe8089cb043",
  "project_id": "a59a3c70-54e7-4b71-a321-099d87b35b8c",
  "url": "/__l5e/assets-v1/13a18b1e-d6b4-4083-9318-dbe8089cb043/demo-ilya.mp3",
  "r2_key": "a/v1/a59a3c70-54e7-4b71-a321-099d87b35b8c/13a18b1e-d6b4-4083-9318-dbe8089cb043/demo-ilya.mp3",
  "original_filename": "demo-ilya.mp3",
  "size": 823004,
  "content_type": "audio/mpeg",
  "created_at": "2026-08-13T11:34:29Z"
}
